import React, { useContext, useEffect } from "react";
import "../../CSS/home.css";
import "animate.css";
import FirstComponent from "./FirstComponent";
import SecondComponent from "./SecondComponent";
import Team from "./Team";
import { MenuContext } from "../../App";

function Home() {
  const [isMenuClicked, setIsMenuClicked] = useContext(MenuContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if(isMenuClicked){
      setIsMenuClicked(!isMenuClicked);
    }
  }, []);

  return (
    <div className="w-full py-10 md:py-8 flex flex-col justify-center items-center">
      <FirstComponent />
      <SecondComponent />
      <Team />
    </div>
  );
}

export default Home;
